// extracted by mini-css-extract-plugin
export default {"horizontalContainer":"AttachmentCard_horizontalContainer__WFZrz","verticalContainer":"AttachmentCard_verticalContainer__5+Uen","relevantRow":"AttachmentCard_relevantRow__g+LoG"};